// Copyright 2024, Imprivata, Inc.  All rights reserved.
// NOTE: This is temporary until feature flags have been properly implemented
import { _getEnv } from './api/utils';
import featureFlags from './featureFlags.json';

export type FeatureFlags = typeof featureFlags;

export enum ENVIRONMENT {
  local = 1,
  dev = 2,
  int = 3,
  eph = 4,
  stg = 5,
  prod = 6,
  prod_eu = 7,
  prod_au = 8,
}

export const TldToEnv: Record<string, ENVIRONMENT> = {
  au: ENVIRONMENT.prod_au,
  eu: ENVIRONMENT.prod_eu,
};

export type FeatureEnvironment = keyof typeof ENVIRONMENT;

export type FeatureConfig = {
  PENDO_API_KEY: string;
};

export function featureSupported(feature: keyof FeatureConfig): boolean {
  const env = _getEnv();
  let featureEnv: FeatureEnvironment = 'prod';

  if (ENVIRONMENT[env]) {
    featureEnv = ENVIRONMENT[env] as unknown as FeatureEnvironment;
  }
  const currentLevel = ENVIRONMENT[featureEnv].valueOf();
  const featureLevel = Object.keys(ENVIRONMENT)
    .filter((key) => Number.isNaN(Number(key)))
    .find((key) => {
      const envFeatures = featureFlags[key.toLowerCase() as keyof FeatureFlags];
      return (
        feature in envFeatures &&
        typeof envFeatures[feature as keyof typeof envFeatures] === 'boolean' &&
        envFeatures[feature as keyof typeof envFeatures]
      );
    });

  console.debug('[featureFlagUtils] feature flags: ', {
    featureEnv,
    currentLevel,
    featureLevel,
  });

  if (featureLevel) {
    return currentLevel <= ENVIRONMENT[featureLevel as keyof typeof ENVIRONMENT];
  }

  return false;
}

export function getFeatureFlags() {
  const currentEnv = _getEnv();
  let features = featureFlags['prod' as keyof FeatureFlags];

  if (Object.keys(featureFlags).includes(currentEnv.toString())) {
    features = featureFlags[currentEnv as unknown as keyof FeatureFlags];
  }

  console.debug('[featureFlagUtils] feature flags: ', {
    currentEnv,
    features,
  });
  return features;
}
